import { axiosClient } from '@nx-frontend/shared/api';

export type RenameWorkspaceTagPayload = {
  workspaceId: string;
  tag: string;
  newName: string;
};
export const renameWorkspaceTag = async ({
  workspaceId,
  tag,
  newName,
}: RenameWorkspaceTagPayload): Promise<boolean> => {
  try {
    await axiosClient.put(`/v2/api/workspaces/${workspaceId}/tags/${encodeURIComponent(tag)}`, { newName });
    return true;
  } catch (err) {
    console.log(`renameWorkspaceTag: ${err}`);
    return false;
  }
};
